<template>
<div class="center-warp">
  <div class="inner">
    <div class="box-filter-line d-flex-between">
      <div class="d-flex">
        <!--<div class="box-search d-flex-between">-->
        <!--  <input type="text" placeholder="消息分类" v-model="queryParams.title" @keydown.enter="handleQuery">-->
        <!--  <div class="iconfont icon-sousuo" @click="handleQuery"></div>-->
        <!--</div>-->

        <el-select
          v-model="queryParams.title"
          placeholder="消息分类"
          size="small"
          clearable
          class="box-search"
          @change="handleQuery"
        >
          <el-option v-for="item in messageTypeOptions" :key="item.id" :label="item.name" :value="item.name"></el-option>
        </el-select>

        <div class="box-search d-flex-between">
          <Input :placeholder="'消息内容'" v-model="queryParams.keyWords" @enter="handleQuery" />
          <div class="iconfont icon-sousuo" @click="handleQuery"></div>
        </div>
        <el-select
          v-model="queryParams.is_look"
          placeholder="读取状态"
          size="small"
          clearable
          class="box-search"
          @change="handleQuery"
        >
          <el-option label="已读" :value="1"></el-option>
          <el-option label="未读" :value="0"></el-option>
        </el-select>
        <div class="reset-btn" @click="handleReset">重置</div>
      </div>
      <div class="read-btn" @click="readAll"><img src="../../assets/img/news_center/clear-icon.png" alt="">全部已读</div>
    </div>
    <div class="box-table" v-loading="loading">
      <div class="box-table-tr2 black-14" v-for="(row, index) in list" :key="index" @click="handleSysMessageClick(row)">
        <div class="dot-position" :class="{'bg-red': row.is_look === 0}"></div>
        <div class="title">{{ row.title }}</div>
        <div class="content">{{ row.content }}</div>
        <div class="time">{{ row.created_at2 }}</div>
      </div>
      <Empty v-if="!list.length" :img-width="'200px'" :info="'暂无消息'" />
    </div>
    <Pagination :total="total" :page.sync="queryParams.page" :last_page="last_page" @pagination="getList" :key="queryParams.page" />

  </div>
</div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {getSysMessageList, sysMessageAllLook, sysMessageLook} from "@/http/message";
import toPageBySysMessage from "@/mixin/toPageBySysMessage";
import {GetListByTypeCode} from "@/http/api";

export default {
  name: "index",
  components: { Pagination },
  mixins: [toPageBySysMessage],
  data(){
    return{
      list: [],
      total: 0,
      last_page: 0,
      loading: false,
      queryParams: {
        page: 1,
        pageSize: 20,
        title:'',
        keyWords: undefined,
      },

      messageTypeOptions: [],
    }
  },
  created() {
    this.getList();

    GetListByTypeCode({type_code: ['sys_message_type']}).then(res => {
      this.messageTypeOptions = res.data.sys_message_type
    })
  },
  methods:{
    getList() {
      this.loading = true
      getSysMessageList(this.queryParams).then(res => {
        this.list = res.data.data
        this.total = res.data.total
        this.last_page = res.data.last_page
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    handleReset(){
      this.queryParams.title = ''
      this.queryParams.keyWords = ''
      this.queryParams.is_look = undefined
      this.handleQuery()
    },
    // 全部已读
    readAll() {
      const message = `是否确认全部已读`;
      const title = `警告`;
      const options = {
        confirmButtonText: `确认`,
        cancelButtonText: `取消`,
        type: 'warning',
      };
      this.$confirm(message, title, options)
        .then(async () => {
          sysMessageAllLook().then(res => {
            this.$notify({
              title: `成功`,
              dangerouslyUseHTMLString: true,
              message: `操作成功`,
              type: 'success',
            });
            this.getList();
          });
        })
        .catch(err => {
          console.error(err);
        });
    },
    handleSysMessageClick(row) {
      this.toPageBySysMessage(row);
    },
  }
}
</script>

<style scoped src="../../assets/css/news_center.css"></style>
<style scoped src="../../assets/css/box.css"></style>
<style>
.box-search input{
  border: none;
  height: 30px !important;
}

</style>
